<template>





          <div class="new-buisness" v-if="loaded && ready">


              <div class="content-quest" :class="screen">

                  <div class="quest-block _intro">
                      <div class="intro-nb" >
                          <h1>{{getObj('layout').layout.title[lang].name}}</h1>
                          <p>   {{getObj('layout').layout.intro[lang].name}} </p>
                          <div class="cta-nb" v-on:click="nextStep('form')" v-if="lang == 0"> <span>+</span> iniciar</div>
                          <div class="cta-nb" v-on:click="nextStep('form')" v-if="lang == 1"> <span>+</span> start</div>
                      </div>

                  </div>

                  <div class="quest-block _form">
                      <div class="form-box">


                          <div class="title-form" >{{getObj('layout').layout.title_form[lang].name}}</div>

                          <form  class="" :class="{'sent' : sent }">


                              <div class="input-row">
                                  <input autocomplete="off"  type="text" :placeholder="labels.name[lang]" v-model="name" id="name" v-on:change="changeInput" v-on:keydown="changeInput" v-on:keypress="changeInput"  v-on:input="changeInput" v-on:paste="changeInput" v-on:click="changeInput" v-on:focus="removePlaceholder" v-on:blur="restorePlaceholder">
                                  <input autocomplete="off"  type="text" placeholder="email" v-model="email" id="email" v-on:change="changeInput" v-on:keydown="changeInput" v-on:keypress="changeInput"  v-on:input="changeInput" v-on:paste="changeInput" v-on:click="changeInput" v-on:focus="removePlaceholder" v-on:blur="restorePlaceholder">
                              </div>
                              <div class="input-row">
                                  <input autocomplete="off"  type="text" :placeholder="labels.phone[lang]" v-model="phone" id="phone" v-on:change="changeInput" v-on:keydown="changeInput" v-on:keypress="changeInput"  v-on:input="changeInput" v-on:paste="changeInput" v-on:click="changeInput" v-on:focus="removePlaceholder" v-on:blur="restorePlaceholder">
                                  <input autocomplete="off"  type="text" :placeholder="labels.company[lang]" v-model="company" id="company" v-on:change="changeInput" v-on:keydown="changeInput" v-on:keypress="changeInput"  v-on:input="changeInput" v-on:paste="changeInput" v-on:click="changeInput" v-on:focus="removePlaceholder" v-on:blur="restorePlaceholder">
                              </div>


                              <div class="input-row">

                                  <div class="rgpd"  v-on:click="goChecked()">
                                      <div class="chk" :class="{'checked' : checked }" >     </div>
                                      <span> {{getObj('layout').layout.rgpd[lang].name}}</span>
                                  </div>

                                  <div class="cta-nb submit" v-on:click="nextStep('general')" :class="{'vis' : !error }" v-if="lang == 0">  <span>+</span> continuar</div>
                                  <div class="cta-nb submit" v-on:click="nextStep('general')" :class="{'vis' : !error }" v-if="lang == 1">  <span>+</span> continue</div>
                              </div>
                          </form>
                      </div>
                  </div>



                  <div class="quest-block _general">
                      <div class="container"  >
                          <div class="quest-console">
                              <div class="quest-item">
                                  <div class="quest-item-box" >
                                      <div class="quest-title"> {{getObj('general').topic[lang].name}}</div>
                                      <div class="question-item"  v-for="(q, index2) in  getObj('general').question"  :key="index2">
                                          <div class="question-item-label" v-html="q.label[lang].name"></div>
                                          <textarea rows="3" v-if="q.type == 'input'" v-model="general[index2].a" v-on:change="changeTextArea(step)" v-on:keydown="changeTextArea(step)" v-on:input="changeTextArea(step)"></textarea>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>


                      <div class="cta-nb submit" v-on:click="nextStep('balls')" :class="{'vis' : vGeneral() }" v-if="lang == 0">  <span>+</span> continuar</div>
                      <div class="cta-nb submit" v-on:click="nextStep('balls')" :class="{'vis' : vGeneral() }" v-if="lang == 1">  <span>+</span> continue</div>
                  </div>
                  <div class="quest-block _balls">

                      <div class="quest-block-wrap">
                          <div class="label-quest"> {{getObj('intro').question[0].label[lang].name}}</div>

                          <div class="quest-balls all" id="quest-balls" >
                              <div class="quest-ball" :class="{'selected' : quest.includes(index)}" v-for="(item, index) in  getAllObj()" v-on:click="selectObj(index)" :style="styleBalls.ball">
                                  <span :style="styleBalls.font">   {{item.topic[lang].name}}  </span>
                              </div>
                          </div>

                          <div class="cta-nb set-balls" v-on:click="nextStep('quest')" :class="{'vis' : quest.length > 0 }" v-if="lang == 0"> <span>+</span> continuar</div>
                          <div class="cta-nb set-balls" v-on:click="nextStep('quest')" :class="{'vis' : quest.length > 0 }" v-if="lang == 1"> <span>+</span> continue</div>
                      </div>

                  </div>


                  <div class="quest-block _quest">
                      <div class="container" :id="'questCont' + step" >
                          <div class="quest-console">


                              <div class="quest-item"  v-for="(item, index) in  questMaster" v-if="step == index" :key="index" :id="'questSetp' + index">

                                  <div class="quest-item-box" >


                                      <div class="quest-title">{{item.topic[lang].name}}</div>


                                      <div class="question-item"  v-for="(q, index2) in  item.question"  :key="index2">

                                          <div class="question-item-label" v-html="q.label[lang].name"></div>

                                          <textarea rows="3" v-if="q.type == 'input'" v-model="ansMap[item.ID][q.ID]" v-on:change="changeTextArea(step)" v-on:keydown="changeTextArea(step)" v-on:input="changeTextArea(step)"></textarea>

                                          <div class="box-choices" v-if="q.type == 'multiple'">
                                              <div class="option-item"  v-for="(op, index3) in  q.options"  :key="index3">
                                                  <div class="option-row" >
                                                      <div class="chk" :class="[{'checked' : ansMap[item.ID][q.ID][index3] == true}, {'disabled' : ansMap[item.ID][q.ID][index3] == false && thereIsChek(item.ID,q.ID) >= parseInt(q.max)}]" v-on:click="setMultiple(item.ID,q.ID, index3, q.max, op.input)"></div>
                                                      <span v-html="op.label[lang].name"> </span><br>

                                                  </div>



                                                  <textarea rows="3" v-if="op.input && ansMap[item.ID][q.ID][index3] == true" v-model="ansMap[item.ID][q.ID][index3 + 1]" v-on:change="changeTextArea(step)" v-on:keydown="changeTextArea(step)" v-on:input="changeTextArea(step)"></textarea>
                                              </div>

                                              

                                          </div>


                                          <div class="box-choices" v-if="q.type == 'single'">
                                              <div class="option-item"  v-for="(op, index4) in  q.options"  :key="index4">
                                                  <div class="option-row">
                                                      <div class="chk radio"  :class="[{'checked' : ansMap[item.ID][q.ID][index4] == true}, {'disabled' : ansMap[item.ID][q.ID][index4] == false && thereIsChek(item.ID,q.ID) >= parseInt(q.max)}]" v-on:click="setSingle(item.ID,q.ID, index4, q.max, op.input)"></div>
                                                      <span v-html="op.label[lang].name"> </span>
                                                  </div>
                                                  <textarea rows="3" v-if="op.input && ansMap[item.ID][q.ID][index4] == true" v-model="ansMap[item.ID][q.ID][index4 + 1]" v-on:change="changeTextArea(step)" v-on:keydown="changeTextArea(step)" v-on:input="changeTextArea(step)"></textarea>

                                              </div>


                                          </div>


                                          <div class="quest-balls child"  v-if="q.type == 'child'">

                                              <div class="quest-ball" :class="{'selected' : chil.WP ==  ansMap[item.ID][q.ID]}" v-for="(chil, index4) in  item.childs" v-on:click="selectChild(item.ID, q.ID, chil.WP)" :style="styleBalls.ball">
                                                  <span :style="styleBalls.font">   {{chil.topic[lang].name}} </span>
                                              </div>



                                          </div>

                                          <transition name="fade">

                                              <div class="child-quest-box"  v-if="q.type == 'child' && ansMap[item.ID][q.ID] != 99">
                                                  <div class="quest-title">{{getChild(ansMap[item.ID][q.ID]).topic[lang].name}}</div>
                                                  <div class="question-item"  v-for="(qChild, iChild) in  getChild(ansMap[item.ID][q.ID]).question"  :key="iChild">
                                                      <div class="question-item-label" v-html="qChild.label[lang].name"></div>

                                                      <textarea rows="3" v-if="qChild.type == 'input'"  v-model="ansMap[getChildIndex(ansMap[item.ID][q.ID])][qChild.ID]" v-on:change="changeTextArea(step)" v-on:keydown="changeTextArea(step)" v-on:input="changeTextArea(step)"></textarea>


                                                  </div>


                                              </div>
                                          </transition>







                                      </div>

                                      <!--div class="ques">

                                          <p class="text-ques"  v-html="item.name" >     </p>
                                      </div>






                                      <div class="ans-row"  v-for="(item2, index2) in  item.answers"  v-on:click="setAns(index2)">
                                          <div class="checkbox" :class="{'active' : tempObj.questions[(actQuestion - 1)] == index2}" > </div>
                                          <p class="ans">{{item2.ans}}</p>


                                      </div>



                                      <div v-if="item.comments == 'true'" class="comments">
                                          <textarea :placeholder="item.commentsLabel" v-model="tempObj.comments[(actQuestion - 1)]" v-on:change="changeInput"  v-on:keydown="changeInput" :placeholder="item.commentsLabel"></textarea>
                                      </div-->

                                  </div>




                              </div>


                          </div>
                          <div class="bnts" >
                              <div class="wrap-bnts">
                                  <div class="cta-nb back"  :class="{'active' : 2 > 1}" v-if="step == 0" v-on:click="nextStep('balls')">

                                      <strong v-if="lang == 0"> Anterior</strong>
                                      <strong v-if="lang == 1"> Back</strong>

                                  </div>

                                  <div class="cta-nb back"  :class="{'active' : 2 > 1}" v-if="step > 0" v-on:click="prevStepNum">

                                      <strong v-if="lang == 0"> Anterior</strong>
                                      <strong v-if="lang == 1"> Back</strong>

                                  </div>


                                  <div class="wrap-bar">
                                      <div class="progress-bar" id="progressbar">

                                          <div class="progress-line">
                                              <div class="line" :style="'transform: scaleX(' + scaleQuesion +')'"></div>
                                          </div>
                                          <div class="progress-dot"  v-for="(dot, i) in  questMaster" :key="i" :class="{'filled' : step >= i}"></div>
                                      </div>
                                  </div>

                                  <div class="cta-nb next"  :class="{'active' : validSetp(step)}" v-on:click="nextStepNum" v-if="step < (questMaster.length - 1)">
                                      <strong v-if="lang == 0"> Seguinte</strong>
                                      <strong v-if="lang == 1"> Next</strong>
                                  </div>

                                  <div class="cta-nb next"  :class="{'active' : validSetp(step)}" v-on:click="submitData" v-if="step == (questMaster.length - 1)">
                                      <strong v-if="lang == 0"> Submeter</strong>
                                      <strong v-if="lang == 1"> Submit</strong>
                                  </div>
                              </div>

                          </div>
                      </div>

                  </div>


                  <div  class="quest-block _sent">

                      <div class="sent-nb" >

                           {{getObj('layout').layout.sent[lang].name}}

                      </div>


                  </div>

              </div>









              <div class="project-footer">
                  <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
              </div>




          </div>
      <!--div class="main-brands">


        <div v-for="(item, index) in customers" class="brand-item" :class="{'vis' :  offSet.last >= index}"  >

          <div class="container"  v-on:click="openAcco(index)">
            <div class="brand-item-title" :class="[{'hascases' : item.cases} , {'open': itemOpen === index}]">
              <div class="btn" v-if="item.cases"></div>
              <h1>   {{item.name}}</h1>
            </div>

          </div>


          <div class="brands-cases-box" v-if="item.cases"  :class="{'open': itemOpen === index}" >
            <brands-cases :cases="item.cases" :isMobile="isMobile"></brands-cases>
          </div>






        </div-->









</template>

<script>


import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP, addData} from '../main';

    import FooterNossa from "./FooterNossa";




    export default {

        name: 'New',
      components: {FooterNossa},
      props: ['actRoute', 'isMobile', 'lang'],


        data() {
            return {
                aa: 'dasdsa',

                screen: 'intro',

                labels : {

                    name: ['Nome', 'Name'],
                    email: ['Email', 'Email'],
                    company: ['Empresa', 'Company'],
                    phone: ['Contacto telefonico', 'Phone'],
                },

                general:[],
                checked: false,
                error: true,
                valid :'',
                name: '',
                email: '',
                phone: '',
                company: '',
                vat: '',
                sent : false,

                step : 0,
                totalSteps : 0,
                scaleQuesion:0,

                json: [],

                dataSent: {
                    slug: 'quizdata',
                    name: ''

                },

                quest:[],
                questMaster : [],
                questMasterValid : [],
                styleBalls: {
                    ball: 'width: 200px; height: 300px;',
                    font: 'font-size: 20px; line-height: 30px;',

                },

                sentData: {},
                ansMap: [],
                validQuest : [],
              loaded: false,
              ready: false,



                /*
                _this.tempObj =  {
                    slug: 'emp-quiz',
                    questions : [],
                    comments : [],
                    name: _this.employee.name,
                    token: _this.token,
                    employee: _this.employee
                };

*/
            }
        },


      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'New Business'
          }
        },


      },
      created() {

          const _this = this;


          WP('newbusiness', function (response){

              // console.log(response)




              _this.json = response;

              _this.writeMap(_this.json);
              _this.loaded = true;



              _this.init();


          });
/*


*/
      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
       // $(window).scrollTop(0);
       // $('body, html').scrollTop(0);
      },

      destroyed() {

      },

      methods: {

        init() {

          const _this = this;

          if(_this.loaded && _this.ready){





              // quero que esta minha função atribua a largura de cada filho do elemmento #quest-balls, o total da largura do pai/ numero de filhos deixando umamargem de 20px entre cada um
              $( window ).resize(function() {

                  _this.resizeMe();


              });

              _this.resizeMe();

              setTimeout(()=>{
                  _this.resizeMe();
                  setTimeout(()=>{
                      EVENTBUS.$emit('showFooter');
                  }, 300)
              }, 300)


          }




        },

          resizeMe(){
            const _this = this;

              let totalWidth = 0; // Obtém a largura do elemento pai
              let numberOfChildren = _this.getAllObj().length;
              let childWidth = 0;
              let fontSize = 0;

              if (window.innerWidth >800){
                  totalWidth = window.innerWidth * 0.95;
                  childWidth = totalWidth / numberOfChildren
                  fontSize = (window.innerWidth * 14) /1200;
              }else{
                  totalWidth = window.innerWidth * 0.95;
                  childWidth = totalWidth / 2
                  fontSize = (window.innerWidth * 14) /360;
              }


              _this.styleBalls.ball =  'width: ' + childWidth + 'px; height: ' + childWidth + 'px;' ;
              _this.styleBalls.font =   'font-size: ' + fontSize + 'px; line-height: ' + (fontSize * 1.2) + 'px;';



              /*
              // Define a largura para cada filho
              $questBalls.children().width(childWidth);
              $questBalls.children().height(childWidth);


              $questBalls.children().width(childWidth).find('span')
                  .css('font-size', fontSize + 'px')
                  .css('line-height', (fontSize * 1.2) + 'px');

               */


              this.updateContentQuestHeight();
              this.forceVUE();
          },


          updateContentQuestHeight() {
              var contentQuest = document.querySelector('.content-quest');
              var maxHeight = 0;
              var questBlocks = {};

            try{


                if (this.screen == 'quest'){
                    var questBlocks = document.querySelectorAll('.quest-block');


                    questBlocks.forEach(function(questBlock) {
                        var blockHeight = questBlock.offsetHeight;
                        maxHeight = Math.max(maxHeight, blockHeight);
                    });
                    var questSetp = document.getElementById('questCont' +this.step);

                    var btns = document.querySelector('.btns');
                    maxHeight =     questSetp.offsetHeight;

                }else  if (this.screen == 'intro'){
                     questBlocks = document.querySelector('.quest-block._intro');
                    maxHeight =  questBlocks.offsetHeight;
                }else  if (this.screen == 'form'){
                    var questBlocks = document.querySelector('.quest-block._form');
                    maxHeight =  questBlocks.offsetHeight;
                }else  if (this.screen == 'general'){
                    var questBlocks = document.querySelector('.quest-block._general');
                    maxHeight =  questBlocks.offsetHeight;
                }
                else  if (this.screen == 'balls'){
                     questBlocks = document.querySelector('.quest-block._balls');
                    maxHeight =  questBlocks.offsetHeight;
                }else  if (this.screen == 'sent'){
                     questBlocks = document.querySelector('.quest-block._sent');
                    maxHeight =  questBlocks.offsetHeight;
                }


                contentQuest.style.height = maxHeight + 'px';
            }catch (e) {
                //console.log('...')
            }


          },


          vGeneral(){
            let ret = true;

              this.general.forEach(function(obj, index){
                  if (obj.a == ''){
                      ret = false;
                  }

              });

            return ret;
          },


          writeMap(json){
              const _this = this;

               json.forEach(function(obj, index){
                   _this.ansMap.push([])

                   if (obj.hierarchy === 'general'){
                       obj.question.forEach(function(obj2, index){
                          _this.general.push(
                               {
                                   q : obj2.label[0].name,
                                   a : ''
                               }
                           )

                       });


                   }

                   if(obj.question){
                       obj.question.forEach(function(obj2, index){

                           if(obj2.type === 'multiple' || obj2.type === 'single'){
                               _this.ansMap[obj.ID][obj2.ID] = [];
                               let input = false;
                               obj2.options.forEach(function(aa, i){
                                   _this.ansMap[obj.ID][obj2.ID][i] = false;
                                   if (aa.input){
                                       input = true;
                                   }
                               });

                               if (input){
                                   _this.ansMap[obj.ID][obj2.ID].push('');
                               }

                           }else if(obj2.type === 'input'){
                               _this.ansMap[obj.ID][obj2.ID] = '';
                           }

                            else if(obj2.type === 'child'){
                               _this.ansMap[obj.ID][obj2.ID] = 99;
                           }



                        //  console.log(obj2.type);

                       });
                   }else{

                   }
              });

               //console.log( _this.ansMapValid);

           //   this.forceVUE();
          },

          selectChild(item, q, WP){
                this.ansMap[item][q] = WP;
                console.log( this.ansMap[item][q]);
              this.forceVUE();
              this.loopResizeBlock();
          },

          getChild(WP){

            let ret = {}

              this.json.forEach(function(obj, index){

                  if(obj.WP == WP){
                      ret = obj;
                  }
              });

            return ret;

          },

          getChildIndex(WP){

              let ret = 0

              this.json.forEach(function(obj, index){

                  if(obj.WP == WP){
                      ret = index;
                  }
              });

              return ret;

          },



          setMultiple(parent, q, op, input) {
              // Use Vue.set para garantir reatividade em propriedades aninhadas

              console.log(this.ansMap[parent][q])
              this.$set(this.ansMap[parent][q], op, !this.ansMap[parent][q][op]);
              // Forçar a atualização do componente (opcional)
              //console.log(this.ansMap[parent][q], this.ansMap[parent][q].length - 1,  this.ansMap[parent][q][this.ansMap[parent][q].length - 1] )

              /*
               if(!this.ansMap[parent][q][this.ansMap[parent][q].length - 2]){
                   this.ansMap[parent][q][this.ansMap[parent][q].length - 1] = ''
               }

               */
              this.forceVUE();
               this.loopResizeBlock();

          },


          setSingle(parent, q, op, input) {
              // Define false para todas as opções
              for (const key in this.ansMap[parent][q]) {
                  if (key !== op) {
                      this.$set(this.ansMap[parent][q], key, false);
                  }
              }

              // Define true para a opção atual
              this.$set(this.ansMap[parent][q], op, true);

              this.forceVUE();
              this.loopResizeBlock();

          },

          thereIsChek(parent, q){
            let ret = 0


              this.ansMap[parent][q].forEach(function(obj, index){
                  if (obj == true){
                      ret ++;
                  }
              });



            //console.log(this.ansMap[parent][q])

             // this.forceVUE();

            return ret;
          },



          getMap(id, id2){
              const _this = this;
              let ret = 'sadasd';

              /*
              _this.ansMap.forEach(function(obj, index){

                  if (obj.parent == id && id2 == obj.id ){
                      ret = obj.answer;
                  }
              });

               */

              return ret;
          },



          getObj(h){
            const _this = this;
            let ret = {};


              _this.json.forEach(function(obj, index){

                  if(h === obj.hierarchy){
                      ret = obj;
                  }

              });



              return ret;
          },

          getAllObj(){
              const _this = this;
              let ret = [];
              _this.json.forEach(function(obj, index){
                  if('simple' === obj.hierarchy || 'parent' === obj.hierarchy){

                      ret.push(obj)
                  }

              });

              return ret;
          },


         selectObj(num){
             const _this = this;
             const index =  this.quest.indexOf(num);
             if (index === -1) {
                 _this.quest.push(num);
                 _this.quest.sort((a, b) => a - b); // Ordena o array em ordem crescente
              } else {
                 _this.quest.splice(index, 1);
              }

              _this.questMaster = [];
              _this.quest.forEach(function(index){
                  _this.questMaster.push(_this.getAllObj()[index])
                  //_this.sentData.answers
              });

             _this.json.forEach(function(o){
                 if(o.hierarchy == 'end'){
                     _this.questMaster.push(o)
                 }
                 if(o.hierarchy == 'final'){
                     console.log('AAAAAAAAAAAAAAAAAAAAA');
                     console.log(o);
                     console.log('AAAAAAAAAAAAAAAAAAAAA');
                 }

             });

             _this.validQuest = _this.questMaster;

         },





          nextStep(sreenName){

            console.log(sreenName)

              this.screen =  sreenName
              this.loopResizeBlock();
              const _this = this;
              window.scrollTo({
                  top: 0,
                  behavior: 'smooth' // Para uma rolagem suave, use 'auto' ou 'instant' para uma rolagem instantânea
              });



          },



          nextStepNum(){
              const _this = this;

              if (_this.step < _this.questMaster.length){
                  _this.step ++;
              }else{
                  _this.submitData();
              }

              _this.loopResizeBlock();

              window.scrollTo({
                  top: 0,
                  behavior: 'smooth' // Para uma rolagem suave, use 'auto' ou 'instant' para uma rolagem instantânea
              });

              setTimeout(()=>{
                  _this.forceVUE();
              }, 300)

          },
          prevStepNum(){
              this.step --;
              this.loopResizeBlock();
              const _this = this;
              window.scrollTo({
                  top: 0,
                  behavior: 'smooth' // Para uma rolagem suave, use 'auto' ou 'instant' para uma rolagem instantânea
              });

              setTimeout(()=>{
                  _this.forceVUE();
              }, 300)
          },







          forceVUE(){
              const _this = this;
              _this.$forceUpdate();
              setTimeout(()=>{
                  _this.$forceUpdate();
              }, 300);
          },
          
          
          loopResizeBlock(){

            const _this = this;


            _this.updateContentQuestHeight()
            for (let i = 0; i < 20; i ++){
                setTimeout(function(){
                    _this.updateContentQuestHeight()
                }, 50);
            }
          },




          changeTextArea(i) {
              this.validSetp(i);
              this.forceVUE();
          },



          validSetp(index) {
                 var ret = false;
              var questSetp = document.getElementById('questSetp' +index);



              if (!questSetp) {

                  ret = false;


              }else{

                  ret = true;
                  var textareas = questSetp.querySelectorAll('textarea');

                  for (var i = 0; i < textareas.length; i++) {

                      if (textareas[i].value.trim() === '') {
                          ret =  false; // Pelo menos uma textarea está vazia
                      }
                  }


                  var boxChoicesDivs = questSetp.querySelectorAll('.box-choices');


                  for (var i = 0; i < boxChoicesDivs.length; i++) {
                      var chkDivs = boxChoicesDivs[i].querySelectorAll('.chk.checked');

                      if (chkDivs.length === 0) {
                          ret = false;
                      }
                  }

                 // this.forceVUE();
              }

              return ret; // Todas as textareas estão preenchidas
          },

          getWpChildIndex(wp){
              const _this = this;
              let ret = 0
              _this.json.forEach(function(obj1, index1) {

                  if (wp == obj1.WP){

                      ret = index1
                      console.log(obj1, wp)

                  }


              });
              return ret;
          },



          submitData(){
            const _this = this;


            //console.log(    _this.questMaster)
           // console.log(    _this.json)
          //   console.log(    _this.ansMap)


              let arrIndex = [];
              let tempObj = [];
              let finalObj = {};



              _this.json.forEach(function(obj1, index1) {

                  _this.questMaster.forEach(function(obj2, index2) {


                      if (obj1.ID == obj2.ID){

                          if (_this.ansMap[index1] > 10){
                            //  console.log(obj1.ID, obj2.ID, _this.ansMap[index1], 'passou', obj1.WP);



                              arrIndex.push({o: _this.ansMap[_this.getWpChildIndex(_this.ansMap[index1])], i: _this.getWpChildIndex(_this.ansMap[index1])});
                          }else{
                            //  console.log(obj1.ID, obj2.ID, _this.ansMap[index1], 'virou');
                              arrIndex.push({o: _this.ansMap[index1], i: index1});
                          }


                      }

                  });
              });



              _this.json.forEach(function(obj1, index1) {


                  arrIndex.forEach(function(obj2, index2) {

                      if (obj2.i == index1){
                          //console.log(obj1.topic[0].name);

                          //tempObj[index2].topic = obj1.topic[0].name;
                          //tempObj.questions = {q: [], a:[]};

                          tempObj[index2] = {
                              topic: obj1.topic[0].name,
                              questions: {q: [], a:[]}
                          }

                          obj1.question.forEach(function(q, index3) {

                            //   console.log('q', q.label[0].name);
                              tempObj[index2].questions.q.push(q.label[0].name);

                              obj2.o.forEach(function(ans, index4) {
                                  if (index4 == index3){


                                      if (q.type === 'input'){

                                            //  console.log('r', ans, index4, index3);
                                          tempObj[index2].questions.a.push(ans);

                                      } else if (q.type === 'multiple' || q.type === 'single'){
                                          let tmpOptions = '';
                                          ans.forEach(function(op, index5) {
                                            //  console.log('op', op, q.options[index5].label[0].name)



                                              if (op === true && op !== ''){
                                                //  console.log('op', op,  q.options[index5].label[0].name, ' input: ', q.options[index5].input, ans[index5 + 1]);

                                                  if (!q.options[index5].input){
                                                    //  tempObj[index2].questions.a.push( q.options[index5].label[0].name);

                                                      tmpOptions +=  '• ' + q.options[index5].label[0].name + '<br>';
                                                  }else{
                                                      //tempObj[index2].questions.a.push( q.options[index5].label[0].name + ': ' + ans[index5 + 1]);

                                                      tmpOptions +=  '• ' + q.options[index5].label[0].name + ': ' + ans[index5 + 1] + '<br>';
                                                  }

                                              }
                                          });

                                          tempObj[index2].questions.a.push(tmpOptions);

                                      }
                                  }


                              });


                          });


                          // console.log(tempObj)

                      }

                  });
              });



              finalObj = {
                  name: _this.name,
                  slug: 'quizdata',
                  form: {

                      name: _this.name,
                      email: _this.email,
                      company: _this.company,
                      phone: _this.phone
                  },
                  general: _this.general,
                  quest: tempObj
              }



              addData(finalObj, (data)=>{
                  console.log(data)
                  _this.nextStep('sent')
                  _this.loopResizeBlock();
              })


          },




































         changeInput: function(e){
             if( e.target.id == 'phone'){
                 e.target.value =  e.target.value.replace(/[^0-9+]/g, '');
             }
             this.vat = '';
             this.validateInputs();


         },


         removePlaceholder(e){
           e.target.classList.add('no-placeholder');

         },

         restorePlaceholder(e){
             e.target.classList.remove('no-placeholder');
         },

         goChecked(){

             if(this.checked ){
                 this.checked = false;
             }else{
                 this.checked = true;
             }
             this.validateInputs();
             this.vat = '';

         },

         validateEmail(email) {
             const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
             return regexEmail.test(email);
         },


         validateInputs(){

             if(this.name != '' &&
                 this.validateEmail(this.email) &&
                 this.phone != ''  &&

                 this.checked
             ){
                 this.error= false;
             }else{

                 this.error= true;
             }


             return this.error;
         },


         sendEmail(){

             const _this = this;



             if (!_this.validateInputs()){
                 let obj = {

                     body: `
                           <h1>CONTACTO CHLICK FORM</h1>
                            <p><span style="font-weight: bold;">Nome: </span>${_this.name}</p>
                            <p><span style="font-weight: bold;">Email: </span>${_this.email}</p>
                            <p><span style="font-weight: bold;">Telefone: </span>${_this.phone}</p>
                            <p><span style="font-weight: bold;">Empresa: </span>${_this.company}</p>
                            <p><span style="font-weight: bold;">Mensagem: </span>${_this.message}</p>


   <p>&nbsp;</p>
                           `

                 }


                 _this.error = true;
                 _this.sent= true;
                 $.ajax({
                     type: "POST",
                     url:  'window.URL_FORM',
                     //  data:  JSON.stringify(dataJSON),
                     data: obj,
                     crossDomain: true, // Permitir solicitações cross-domain
                     // dataType: "jsonp", // Tipo de dados para manipular a resposta como JSONP

                     success: function(data){
                         console.log(data)


                         setTimeout(()=>{
                             _this.checked = false,
                                 _this.valid = '';
                             _this.name = '';
                             _this.email = '';
                             _this.phone = '';
                             _this.company = '';
                             _this.vat = '';

                             _this.sent = false;

                         }, 3000);
                     }
                 });
             }


         }








     },
   };

</script>


// WEBPACK FOOTER //
// src/components/New.vue